import { createModalContext } from '#/features/modal';

export const [
  UsernameEditModalProvider,
  useUsernameEditModalView,
  useUsernameEditModalActions,
] = createModalContext('UsernameEdit');
